import React from 'react';
import { FieldInput } from '@magoosh/lib/formik_inputs/field_input/template';
import style from './style.module.scss';
import { paths } from 'config/path_helpers';

export const UserFormGroup: React.FC = () => {
  return (
    <fieldset className="inputs">
      <div className="form-group">
        <div className="help-block">
          If you already have a Magoosh account,{' '}
          <a href={paths.login(true)} onClick={() => window.location.assign(paths.login(true))}>
            sign in here
          </a>
        </div>

        <FieldInput name="email" type="input" label="Email Address" className={style.mediumStringInput} />
        <FieldInput name="password" type="password" label="Password" className={style.mediumStringInput} />
        <FieldInput
          name="passwordConfirmation"
          type="password"
          label="Confirm Password"
          className={style.mediumStringInput}
        />
      </div>
    </fieldset>
  );
};

export default UserFormGroup;
